import { tourKeys } from '../@utils/tourKeys'

export default function getRealTimeHotelSteps() {
    const k = tourKeys('realTimeHotel')

    return [
        {
            target: '.sticky-header',
            contentKey: k.welcome,
            placement: 'bottom',
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            target: '.filter-containers',
            contentKey: k.filters,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '[data-tour="rt-hotels-progress"]',
            contentKey: k.progress,
            placement: 'bottom',
        },
        {
            target: '[data-tour="rt-hotels-blocks"]',
            contentKey: k.blocks,
            placement: 'bottom',
        },
        {
            target: '[data-tour="rt-hotels-table"]',
            contentKey: k.table,
            placement: 'top',
        },
    ]
}
